import React from 'react';
import { Navigate } from 'react-router-dom';
import { AUTH_ROUTER, MAIN_ROUTER } from './constants';

const Login = React.lazy(() => import('container/auth/Login'));
const DashboardHome = React.lazy(() => import('container/main/DashboardHome'));
const DashboardDevice = React.lazy(() => import('container/main/DashboardDevice'));
const DashboardBody = React.lazy(() => import('../container/main/DashboardBody'));
const DashboardVibration = React.lazy(() => import('container/main/DashboardVibration'));
const DashboardLaser = React.lazy(() => import('container/main/DashboardLaser'));
const DashboardMaintenance = React.lazy(() => import('container/main/DashboardMaintenance'));
const DashboardIncident = React.lazy(() => import('container/main/DashboardIncident'));
const DashboardIncidentList = React.lazy(() => import('container/main/DashboardIncidentList'));
const DashboardErrorLogList = React.lazy(() => import('container/main/DashboardErrorLogList'));

/// User
const UserProfile = React.lazy(() => import('container/main/UserProfile'));
const ChangePassword = React.lazy(
  () => import('container/main/ChangePassword')
);

const Department = React.lazy(() => import('container/main/Department'));
const MachineType = React.lazy(() => import('container/main/MachineType'));
const Protocol = React.lazy(() => import('container/main/Protocol'));
const Machine = React.lazy(() => import('container/main/Machine'));
const MailConfig = React.lazy(() => import('container/main/MailConfig'));
const HomeRedirect = () => React.createElement(Navigate, { to: MAIN_ROUTER.DASHBOARD_LASER, replace: true });

export const routesAuth = [
  {
    key: 1,
    path: AUTH_ROUTER.LOGIN,
    component: Login
  }
];

export const routesMain = [
  {
    path: MAIN_ROUTER.HOME,
    component: HomeRedirect
  },
  // Dashboard
  {
    path: MAIN_ROUTER.DASHBOARD_HOME,
    component: DashboardHome
  },
  {
    path: MAIN_ROUTER.DASHBOARD_DEVICE,
    component: DashboardDevice
  },
  {
    path: MAIN_ROUTER.DASHBOARD_BODY,
    component: DashboardBody
  },
  {
    path: MAIN_ROUTER.DASHBOARD_VIBRATION,
    component: DashboardVibration
  },
  {
    path: MAIN_ROUTER.DASHBOARD_LASER,
    component: DashboardLaser
  },
  {
    path: MAIN_ROUTER.DASHBOARD_MAINTENANCE,
    component: DashboardMaintenance
  },
  {
    path: MAIN_ROUTER.DASHBOARD_INCIDENT,
    component: DashboardIncident
  },
  {
    path: MAIN_ROUTER.DASHBOARD_ERROR_LOG_LIST,
    component: DashboardErrorLogList
  },
  {
    path: MAIN_ROUTER.DASHBOARD_INCIDENT_LIST,
    component: DashboardIncidentList
  },
  {
    path: MAIN_ROUTER.DASHBOARD_MATERIAL,
    component: DashboardHome
  },
  {
    path: MAIN_ROUTER.DASHBOARD_FEATURE,
    component: DashboardHome
  },
  {
    path: MAIN_ROUTER.DASHBOARD_ANALYTICS,
    component: DashboardHome
  },
  // Cấu hình
  {
    path: MAIN_ROUTER.CATEGORY_MACHINE_TYPE,
    component: MachineType
  },
  {
    path: MAIN_ROUTER.CATEGORY_PROTOCOL,
    component: Protocol
  },
  {
    path: MAIN_ROUTER.CATEGORY_UNIT,
    component: Department
  },
  {
    path: MAIN_ROUTER.CATEGORY_DEVICE,
    component: Machine
  },
  {
    path: MAIN_ROUTER.CATEGORY_MAIL_CONFIG,
    component: MailConfig
  },
  // Hệ thống
  {
    path: MAIN_ROUTER.SYSTEM_USER,
    component: DashboardHome
  },
  {
    path: MAIN_ROUTER.SYSTEM_ROLE,
    component: DashboardHome
  },
  /// User
  {
    path: MAIN_ROUTER.PROFILE,
    component: UserProfile
  },
  {
    path: MAIN_ROUTER.CHANGE_PASSWORD,
    component: ChangePassword
  }
];
